import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  taEmployeesGroup: []
}

export const mutations = {
  SET_TA_EMPLOYEES_GROUP(state, taEmployeesGroup) {
    state.taEmployeesGroup = taEmployeesGroup
  },
  ADD_TA_EMPLOYEE_GROUP(state, taEmployeeGroup) {
    state.taEmployeesGroup.push(taEmployeeGroup)
  },
  EDIT_TA_EMPLOYEE_GROUP(state, taEmployeeGroup) {
    const index = state.taEmployeesGroup.findIndex(
      e => e.employee_group_uuid === taEmployeeGroup.employee_group_uuid
    )
    if (index !== -1) {
      state.taEmployeesGroup.splice(index, 1, taEmployeeGroup)
    }
  },
  DELETE_TA_EMPLOYEE_GROUP(state, employee_group_uuid) {
    const index = state.taEmployeesGroup.findIndex(
      e => e.employee_group_uuid === employee_group_uuid
    )
    if (index !== -1) state.taEmployeesGroup.splice(index, 1)
  }
}

export const actions = {
  fetchTaEmployeesGroup({ commit }, payload) {
    return ApiService.fetchTaEmployeesGroup(payload)
      .then(res => {
        const taEmployeesGroup = res.data.data
        commit('SET_TA_EMPLOYEES_GROUP', taEmployeesGroup)
      })
      .catch(error => {
        throw error
      })
  },
  fetchTaEmployeeGroupById({ commit }, payload) {
    return ApiService.fetchTaEmployeeGroupById(payload)
      .then(res => {
        const taEmployeeGroup = res.data
        return taEmployeeGroup
      })
      .catch(error => {
        throw error
      })
  },
  addTaEmployeeGroup({ commit }, payload) {
    return ApiService.addTaEmployeeGroup(payload)
      .then(res => {
        const taEmployeeGroup = res.data
        commit('ADD_TA_EMPLOYEE_GROUP', taEmployeeGroup)
        return taEmployeeGroup
      })
      .catch(error => {
        throw error
      })
  },
  editTaEmployeeGroup({ commit }, payload) {
    return ApiService.editTaEmployeeGroup(payload)
      .then(res => {
        const taEmployeeGroup = res.data
        commit('EDIT_TA_EMPLOYEE_GROUP', taEmployeeGroup)
      })
      .catch(error => {
        throw error
      })
  },
  deleteTaEmployeeGroup({ commit }, payload) {
    return ApiService.deleteTaEmployeeGroup(payload)
      .then(() => {
        commit('DELETE_TA_EMPLOYEE_GROUP', payload.employee_group_uuid)
      })
      .catch(error => {
        throw error
      })
  },
  fetchTaEmployeesGroupMember({ commit }, payload) {
    return ApiService.fetchTaEmployeesGroupMember(payload)
      .then(res => {
        const taEmployeeGroupMember = res.data
        return taEmployeeGroupMember
      })
      .catch(error => {
        throw error
      })
  },
  addTaEmployeeGroupMember({ commit }, payload) {
    return ApiService.addTaEmployeeGroupMember(payload).catch(error => {
      throw error
    })
  },
  deleteTaEmployeeGroupMember({ commit }, payload) {
    return ApiService.deleteTaEmployeeGroupMember(payload).catch(error => {
      throw error
    })
  }
}
